"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionConfig = exports.currentSectionName = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const sectionSegments_1 = require("evolution-common/lib/services/questionnaire/sections/segments/sectionSegments");
const widgetsNames_1 = require("./widgetsNames");
const customHelpers_1 = require("../../common/customHelpers");
exports.currentSectionName = 'segments';
const nextSectionName = 'travelBehavior';
const segmentSectionConfig = (0, sectionSegments_1.getSegmentsSectionConfig)({});
// Config for the section
exports.sectionConfig = Object.assign(Object.assign({}, segmentSectionConfig), { 
    // FIXME Remove this line when the next section becomes travelBehavior
    nextSection: nextSectionName, isSectionVisible: function (interview, iterationContext) {
        // FIXME: This is the same visibility logic as the visited places. It
        // should be configurable in some kind of helper called by the main
        // component.
        const person = odSurveyHelper.getPerson({
            interview,
            personId: iterationContext[iterationContext.length - 1]
        });
        const journey = person ? odSurveyHelper.getJourneysArray({ person })[0] : undefined;
        return journey && journey.personDidTrips === 'yes';
    }, onSectionEntry: function (interview, iterationContext) {
        const segmentValuesToUpdate = segmentSectionConfig.onSectionEntry(interview, iterationContext);
        const needUpdateHouseholdSizeValues = (0, customHelpers_1.updateHouseholdSizeFromPersonCount)(interview);
        return !segmentValuesToUpdate && !needUpdateHouseholdSizeValues
            ? undefined
            : (0, merge_1.default)(segmentValuesToUpdate || {}, needUpdateHouseholdSizeValues || {});
    }, widgets: widgetsNames_1.widgetsNames });
exports.default = exports.sectionConfig;
